import React, { useState, useEffect } from 'react';
import '../CSS/BlogDetails.css';
import bottom from '../Images/news12/bottom-img.png';
import news from'../Images/news12/news-image.png';
import img1 from'../Images/news12/middle-img1.png';
import img2 from'../Images/news12/middle-img2.png';


function BlogDetails() {
    return (
        <div className='blog-section'>

            <div className="blog-top">
                <div className="blog-date">
                    १४ ऑगस्ट, २०२४
                </div>

                <div className="blog-heading">
                    जकातवाडीतील भिंतींवर कवितांचे रेखाटन !
                </div>

                <div className="blog-category">
                    <span className="card-category">प्रेम</span>
                </div>

                <div >
                    <img className="blog-img" src= {news} alt="" />
                </div>
            </div>

            <div className="blog-para1">
                <p className='para'>
                    कविता विभाग हा भावनांचा, विचारांचा आणि अभिव्यक्तीचा अवकाश आहे. येथे तुम्हाला विविध प्रकारच्या मराठी कविता वाचायला मिळतील प्रेम, निसर्ग, जीवन, सामाजिक प्रश्न, भक्ती आणि प्रेरणादायक अशा अनेक विषयांवर आधारित. नवोदित आणि प्रसिद्ध कवींच्या रचना येथे एकत्र आल्या  आहेत, ज्या तुमच्या मनाला स्पर्श करून जातील. मराठी भाषेच्या सौंदर्यात गुंफलेली ही कवितांची दुनिया तुम्हाला विचारशीलही करेल आणि भावनांनी भारावूनही टाकेल.
                </p>
            </div>

            <div className="blog-para2">
                <h3 className='blog-para-title'>
                    भारतातील पाहिलं माझ कवितांचं गाव  जकातवाडी
                </h3>

                <p className="para">
                    शिक्षण,कृषि,साहित्य,सहकार,उद्योग,सांस्कृतिक कार्यअशा विविध क्षेत्रा मध्ये कर्तृत्वाची शिखरे पादाक्रांत करणारा सातारा हा क्रांतिकारकांचा जिल्हा म्हणून प्रसिद्ध.विविध क्षेत्रामध्ये स्वत:चे एक वेगळे स्थान निर्माण करणारा जिल्हा इतिहासाच्या पावुलखुणांबरोबर जैवविविधतेने नटलेल्या,साहित्यिक व ऐतिहासिक मोलाचा वाटा जतन करणाऱ्या इथल्या मातीत सेनादलात मर्दमुखी गाजवणाऱ्या शूर शिलेदारांचा जिल्हा,इथल्या यात्रा,जत्रा,सन समारंभ,ग्रंथमहोत्सव आणि उत्सवांची वैभवशाली परंपरा सांभाळत इथे घडत आहेत समाज मन. सातारा एक सृजनात्मक वारसा लाभलेला जिल्हा आहे. इतिहासकार,साहित्यिक,पत्रकार,कवी,कलाकार जन्मास आले.आण्णाभाऊसाठे,साबळे असे शाहीरही याच मातीतलेबा.सी.मर्ढेकर.श्री.म.माटे,कवी यशवंत,वसंत कानेटकर,या सारख्या साहित्यिक नररत्नांनी सातारा जिल्ह्याचा सांस्कृतिक आणि साहित्यिक आसमंत सिद्ध केले.
                </p>
            </div>

            <div className="blog-para3">
                <h2 className="blog-para-title">
                    भारतातील पाहिलं माझ कवितांचं गाव जकातवाडी
                </h2>

                <p className="para">
                    कृष्णाकाठ ज्ञान साधनेची मोठी परंपरा निर्माण झाली विश्वकोषत्याच्याच काही अंतरावर भारतातील पहिलं पुस्तकाचं गाव याच्याच थोड्या अंतरावर निसर्गाच वरदान लाभलेल्याआणिअजिंक्यतारा किल्ल्याच्या कुशीत असलेले खिंडीतील गणपती चे कायम आशिष असणारे जगातील पहिलं कवितांच गाव’जकातवाडी. यागावात पूर्वी सातारा येथे जाण्यासाठी जकात घेतली जायची यावरून या गावास जकातवाडी हे पडले असल्याच इतिहास आहे.या गावात चैत्र पौर्णिमेला गावाची यात्रा असते.या गावात वाचन संस्कृती रुजावी तिचा विकास व्हावा,वाचाल तर वाचाल,गाव तेथे ग्रंथालय या विचाराने २६ ऑक्टोबर१९९२ साली दीपावली पाडव्याच्या दिवशी विद्यावर्धिनी सार्वजनिक ग्राम वाचनालय सुरु करण्यात आले त्याचा परिणाम म्हणून गावात वाचन संस्कृती रुजू लागली तेव्हा पासून वाचनासाठी अशी साधन गावात उपलब्ध झाली ती वाचनालयाचे माध्यमातून.आज वाचनालय ब वर्गात आहे.वाचनालयात१५ हजाराहून अधिक पुस्तक आहेत. वाचनालया मार्फत विविध कार्यक्रमांचे आयोजन केले जाते यामध्ये कविसंमेलन,मी वाचलेले पुस्तक वक्तृत्व स्पर्धा ,कथाकथन स्पर्धा,गौरी सजावटस्पर्धाज्या माध्यमातून स्त्रियांच्या सृजनात्मक कला आणि वाचन यामुळे वाचन संस्कृती वाढीस मदत होते.दिवाळीच्या काळात विद्यार्थी आणि युवकांसाठी सुंदर किल्ला स्पर्धा,घेण्यात येते याशिवाय संस्कार शिबीर घेण्यात येतात. विद्यावर्धिनी सार्वजनिक ग्राम वाचनालय आणि प्राथमिक शिक्षक अॅकॅडमीसातारा यांचे संयुक्त विद्यमाने राज्यस्तरीय निबंध स्पर्धा,कथाकथन,कविसंमेलनाचे आयोजन,आयडियल टीचर्स अॅकॅडमी,सातारायांचे मार्फत विविध उपक्रम घेण्यात आले.
                </p>
            </div>

            <div className="kavita-sec">
                <h3 className="kavita-title">
                    कवितांचं गाव जकातवाडी भावी उपक्रम
                </h3>

                <div className="kavita">
                    <p>वाचन संस्कृती वाढविणे.</p>
                    <p>जकातवाडी प्रत्येक घरापुढील भिंतींवर कविता आणि त्या अनुसार चित्र पेंटिंग करणे</p>
                    <p>गावसाहित्यिक पर्यटन म्हणून विकसित करणे.</p>
                    <p>गावात पर्यटन पूरक स्वयं रोजगार तयार करणे</p>
                    <p>कविता लेखन कार्यशाळा घेणे.</p>
                    <p>कवितांच्या पुस्तकाचे प्रकाशन करणे.</p>
                    <p>गावात विविध मंडळांच्या सहयोगाने कविसंमेलनाचे आयोजन करणे</p>
                    <p>मला आवडलेल्या कवितांचे कार्यक्रम घेणे.</p>
                    <p>कवीचे जन्मदिवस साजरे करणे.</p>
                    <p>गावातील घरांना प्रसिद्ध कवींच्या पुस्तकांची नावे देणे.</p>
                    <p>वाचनालयात कवितांची पुस्तके उपलब्ध करून देणे.</p>
                    <p>कवितांचे पुस्तकांना पुरस्कार देऊन कवींचा आणि कलाकारांचा गौरव करणे</p>
                    <p>कवीच्या जन्म दिनी त्यांच्या कवितांचा कार्यक्रम घेणे.</p>
                    <p>गावात कविसंमेलनासाठी कायम स्वरूपी सभागृह बांधणे</p>
                    <p>या सर्व कामासाठी गावातील लोकसहभाग घेणे.</p>
                    <p>गावातील रिक्षा चालकांना गाईडचे प्रशिक्षण देऊन सहकार्य घेणे</p>
                    <p>विविध साहित्य विषयक संस्था, लोक प्रतिनिधी, राज्य शासन यांच्याकडून मार्गदर्शन आणि सहकार्य घेणे.</p>
                    <p>नवोदित कवींना कायम स्वरूपी व्यासपीठ उपलब्ध करून देणे.</p>
                    <p>विविध सांस्कृतिक कार्यक्रमांचे आयोजन करून भावी पिढी कार्यक्षम बनविणे.</p>
                    <p>साहित्यिकव सांस्कृतिक सभागृह आणि निवास बांधणे</p>
                </div>

            </div>

            <div className="info-sec">
                <div className="info-img-sec">
                    <img src= {img1} alt="" className="image1" />
                    <img src= {img2} alt="" className="image2" />
                </div>

                <p className="info-text">
                    कामाची सुरुवात सुंदर चित्र आणि काव्य पंक्ती रेखाटण्यासाठी राज्यस्तरीय पेंटिंग स्पर्धा ३१ डिसेंबर २०१८ रोजी घेण्यात आली त्या स्पर्धेच्यामाध्यमातून गावातील काही भिंतींवर कविता आणि त्यालाअनुसार चित्रकाढण्याचे काम सुरु झाले.आणि खऱ्या अर्थाने कामाला सुरुवात झाली.त्याचा बक्षिस वितरण समारंभ सातारा जिल्हा ग्रंथमहोत्सवात घेण्यात आला त्यामुळे हा प्रकल्पसर्वांपर्यंत पोहचण्यास मदत झाली. याकामाची दखल विविध वृत्तपत्रांनी घेतली आणि कामाला अधिक सुरुवात झाली आणि गावकऱ्यांना कवितांचं गाव जकातवाडी पुढे घेऊन जाण्याचा मार्ग मोकळा झाला.याचाच भाग म्हणून मुल मामाच्या गावाला जायच्या ऐवजी कवितांच्या गावाला जाऊन त्यांनी आपल्या छोट्या हाताच्या कुंचल्यातून आपल्या कल्पना विश्वातील भव्य चित्र साकारली. वृत्तपत्रांतील बातम्या पाहून कवितांचं गाव जकातवाडीची दखल झी २४ तास या वृत्तवाहिनीने घेतली आणि या प्रकल्पाची माहिती सर्वांपर्यंत पोहचली. सध्या गावातील ५०-६०ठिकाणी या कवितांचे पेंटिंग रेखाटन झालेले आहे.अजून खूप काम करावयाचे आहे त्यासाठी चित्रकार आणि या प्रकल्पाला प्रोत्साहन देणाऱ्या विचारांची गरज आहे यासाठी आपल्या मार्गदर्शनाचीआणि उत्स्फूर्त सहकार्याची आवश्यकता आहे.तरी हे सहकार्य आणि मार्गदर्शन आपण कराल ही अपेक्षा आहे.त्याच प्रमाणे सदर प्रकल्पाला आपल्या सारख्या आश्रय दात्यांनी आशीर्वाद देऊन हा प्रकल्प विकसित होण्यास सहकार्य करावे आणि अशाच प्रकारे आपल्या इतर मित्र परिवारातील आश्रय दात्यांना या कामासाठी प्रोत्साहित करावे.ही विनंती.
                </p>
            </div>

            <div className="kavisammelan">
                <img src={bottom} alt="" className="kavisammelan-img" />

                <p className="kavisammelan-text">
                    कविसंमेलन मार्गदर्शन करताना सातारा जिल्हा ग्रंथालय अधिकारी मा. आमित सोनवणे वाचनालयाचे अध्यक्ष प्रल्‌हाद पारटे ज्येष्ठ साहित्यिक डॉ. उमेश करंबेळकर मा. सरपंच चंद्रकांत सणस उपसरपंच हणमंत भोसले.
                </p>
            </div>



        </div>
    );
}

export default BlogDetails;
